import { render, staticRenderFns } from "./MemberWriteBankLayout.vue?vue&type=template&id=bed4484a&scoped=true"
import script from "./MemberWriteBankLayout.vue?vue&type=script&lang=js"
export * from "./MemberWriteBankLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed4484a",
  null
  
)

export default component.exports